import DomainEntity from '@/models/DomainEntity'

export default class StrategyTrainings extends DomainEntity {
  static get collectionName() {
    return 'strategytrainings/'
  }

  static get parentKey() {
    return 'strategy'
  }

  static defaults() {
    return {
      add: [],
      update: {},
    }
  }
}
